import { DetailedHTMLProps, HTMLAttributes } from 'react';

import styles from './PerceptedBlock.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	children: string;
	className?: string;
	classNames?: string[];
	info?: boolean;
};

export function PerceptedBlock(props: TProps) {
	const {
		className = '',
		classNames: classNamesOuter = [],
		children,
		info,
		...restProps
	} = props;

	const classNames = [styles.text, ...classNamesOuter];
	if (className) {
		classNames.push(className);
	}

	if (info) {
		classNames.push(styles.info);
	}

	return (
		<div className={ classNames.join(' ') } { ...restProps }>{ children }</div>
	);
}
